/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_DeleteInputs */

const en_us2_profile_delete = /** @type {(inputs: Profile_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete account`)
};

const pt_br2_profile_delete = /** @type {(inputs: Profile_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir conta`)
};

const es_419_profile_delete = /** @type {(inputs: Profile_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar cuenta`)
};

const pt_pt2_profile_delete = /** @type {(inputs: Profile_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar conta`)
};

const fr_fr2_profile_delete = /** @type {(inputs: Profile_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le compte`)
};

const de_de2_profile_delete = /** @type {(inputs: Profile_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto löschen`)
};

const it_it2_profile_delete = /** @type {(inputs: Profile_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina account`)
};

/**
* | output |
* | --- |
* | "Delete account" |
*
* @param {Profile_DeleteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_delete = /** @type {((inputs?: Profile_DeleteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_DeleteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_delete(inputs)
	if (locale === "es-419") return es_419_profile_delete(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_delete(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_delete(inputs)
	if (locale === "de-DE") return de_de2_profile_delete(inputs)
	if (locale === "it-IT") return it_it2_profile_delete(inputs)
	return en_us2_profile_delete(inputs)
});
export { profile_delete as "profile.delete" }